import LoadingSpinner from '$tablet-app/src/app/components/LoadingSpinner';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { showErrorToast } from '$tablet-app/src/app/toasts';
import { Button } from '@akin-home/buttons/native';
import { TextInput } from '@akin-home/forms/native';
import { Text } from '@akin-home/text/native';
import { useState } from 'react';
import styled from 'styled-components/native';

type Props = {
  loading?: boolean;
  onPressSubmit(reset_code: string, password: string): void;
};

export function ForgotPasswordEnterResetCodeForm(props: Props) {
  const { loading } = props;

  const [reset_code, setResetCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm_password, setConfirmPassword] = useState('');

  function onPressSubmit() {
    if (password !== confirm_password) {
      showErrorToast({ text1: 'Passwords do not match' });
      return;
    }

    props.onPressSubmit(reset_code, password);
  }

  return (
    <Container>
      <Text>Enter your reset code and new password</Text>
      <Spacer height="15px" />
      <TextInput
        placeholder="Reset code"
        value={reset_code}
        onChangeText={setResetCode}
      />

      <TextInput
        placeholder="New Password"
        value={password}
        onChangeText={setPassword}
      />

      <TextInput
        placeholder="Confirm new password"
        value={confirm_password}
        onChangeText={setConfirmPassword}
      />

      <Button size="large" onPress={onPressSubmit} disabled={loading}>
        {loading ? <LoadingSpinner color="white" size="large" /> : 'Submit'}
      </Button>
    </Container>
  );
}

const Container = styled.View`
  gap: 15px;
  max-width: 500px;
  width: 100%;
  align-self: center;
  justify-content: center;
`;
